import { LitElement, html, utils } from '@hh/global.js'

class HHFooter extends LitElement {
  constructor() {
    super()
    this.accordions = this.querySelectorAll('.js-footer-accordion')
    this.mobileBreakpoint = '(max-width: 749px)'
  }

  connectedCallback() {
    this.attachEvents()
  }

  attachEvents() {
    ;['load', 'resize'].forEach((eventName) => {
      window.addEventListener(eventName, () => {
        if (window.matchMedia(this.mobileBreakpoint).matches) {
          this.closeAccordions()
        } else {
          this.openAccordions()
        }
      })
    })

    this.accordions.forEach((accordion) => {
      const summaryElement = accordion.querySelector('summary')
      const summaryLink = summaryElement.querySelector('a')

      summaryElement.addEventListener('click', (event) => {
        if (!window.matchMedia(this.mobileBreakpoint).matches) {
          if (summaryLink) {
            window.location.href = summaryLink.getAttribute('href')
          }
          event.preventDefault()
        }
      })
    })
  }

  closeAccordions() {
    this.accordions.forEach((accordion) => {
      accordion.querySelector('details').removeAttribute('open')
    })
  }

  openAccordions() {
    this.accordions.forEach((accordion) => {
      accordion.querySelector('details').setAttribute('open', true)
    })
  }
}

customElements.define('hh-footer', HHFooter)
